const Agency = () => import('@/modules/demand/agency/AgencyList')
const Debt = () => import('@/modules/demand/debt/DebtList')
const Stock = () => import('@/modules/demand/stock/StockList')
const GqNeed = () => import('@/modules/demand/gqneed/PageList')
const DbNeed = () => import('@/modules/demand/dbneed/PageList')
const YhLqPageList = () => import('@/modules/demand/dbneed/YhLqPageList')
const YhCsPageList = () => import('@/modules/demand/dbneed/YhCsPageList')
const DbShPageList = () => import('@/modules/demand/dbneed/DbShPageList')
const DbLqPageList = () => import('@/modules/demand/dbneed/DbLqPageList')
const DbSqPageList = () => import('@/modules/demand/dbneed/DbSqPageList')
const YhJdPageList = () => import('@/modules/demand/dbneed/YhJdPageList')
const YhSxPageList = () => import('@/modules/demand/dbneed/YhSxPageList')
const YhFkPageList = () => import('@/modules/demand/dbneed/YhFkPageList')
const WebSiteDbNeedForm = () => import('@/modules/demand/dbneed/operators/WebSiteDbNeedForm')
const WebSiteDbLoanForm = () => import('@/modules/demand/dbneed/operators/WebSiteDbLoanForm')

export default [
  {

    path: '/demand/agency',
    name: 'agency',
    component: Agency,
    meta: {
      title: '普通需求',
      isBlack: true
    },
  },
  {

    path: '/demand/debt',
    name: 'debt',
    component: Debt,
    meta: {
      title: '贷款需求',
      isBlack: true
    },
  },

  {

    path: '/demand/stock',
    name: 'stock',
    component: Stock,
    meta: {
      title: '融资需求',
      isBlack: true
    },
  },

  {
    path: '/gqNeed',
    name: 'gqNeed',
    component: GqNeed,
    meta: {
      title: '长兴基金需求',
      isBlack: true
    },
  },

  {
    path: '/dbNeed',
    name: 'dbNeed',
    component: DbNeed,
    meta: {
      title: '我的需求',
      isBlack: true,
    },
  },

  {
    path: '/yhlq',
    name: 'yhlq',
    component: YhLqPageList,
    meta: {
      title: '银行领取',
      isBlack: true
    },
  },
  {
    path: '/yhcs',
    name: 'yhcs',
    component: YhCsPageList,
    meta: {
      title: '银行需求',
      isBlack: true
    },
  },

  {
    path: '/dbsh',
    name: 'dbsh',
    component: DbShPageList,
    meta: {
      title: '担保审核',
      isBlack: true
    },
  },
  {
    path: '/dblq',
    name: 'dblq',
    component: DbLqPageList,
    meta: {
      title: '担保领取',
      isBlack: true
    },
  },

  {
    path: '/dbsq',
    name: 'dbsq',
    component: DbSqPageList,
    meta: {
      title: '担保申请',
      isBlack: true
    },
  },

  {
    path: '/yhjd',
    name: 'yhjd',
    component: YhJdPageList,
    meta: {
      title: '银行尽调',
      isBlack: true
    },
  },
  {
    path: '/yhsx',
    name: 'yhsx',
    component: YhSxPageList,
    meta: {
      title: '银行授信',
      isBlack: true
    },
  },
  {
    path: '/yhfk',
    name: 'yhfk',
    component: YhFkPageList,
    meta: {
      title: '银行放款',
      isBlack: true
    },
  },

  {
    path: '/WebSiteDbNeedForm',
    name: 'WebSiteDbNeedForm',
    component: WebSiteDbNeedForm,
    meta: {
      title: '担保需求',
      isBlack: false,
      fullscreen: true,
    },
  },

  {
    path: '/WebSiteDbLoanForm',
    name: 'WebSiteDbLoanForm',
    component: WebSiteDbLoanForm,
    meta: {
      title: '贷款需求',
      isBlack: false,
      fullscreen: true,
    },
  },

  {
    path: '/MyScDepositOrder',
    name: 'MyScDepositOrder',
    component: () => import('@/modules/demand/scDepositOrder/PageMyList'),
    meta: {
      title: '商品需求申请',
      isBlack: true,
      // fullscreen: true,
    },
  },
  {
    path: '/ManageScDepositOrder',
    name: 'ManageScDepositOrder',
    component: () => import('@/modules/demand/scDepositOrder/PageJgList'),
    meta: {
      title: '商品需求管理',
      isBlack: true,
      // fullscreen: true,
    },
  },
  {
    path: '/AddScDepositOrder',
    name: 'AddScDepositOrder',
    component: () => import('@/modules/demand/scDepositOrder/operators/WebAddForm'),
    meta: {
      title: '商品需求发布',
      isBlack: false,
      fullscreen: true,
    },
  },

  {
    path: '/MyRzCompanyInfo',
    name: 'MyRzCompanyInfo',
    component: () => import('@/modules/demand/rzCompanyInfo/PageList'),
    meta: {
      title: '我的融资需求',
      isBlack: true,
      // fullscreen: true,
    },
  },
  {
    path: '/RzInvestorInfo',
    name: 'RzInvestorInfo',
    component: () => import('@/modules/demand/rzInvestorInfo/PageList'),
    meta: {
      title: '投资者信息',
      isBlack: true,
      // fullscreen: true,
    },
  },
  {
    path: '/CompanySendToMe',
    name: 'CompanySendToMe',
    component: () => import('@/modules/demand/rzCompanyInfo/PageCompanySendToMeList'),
    meta: {
      title: '企业投递的融资信息',
      isBlack: true,
      // fullscreen: true,
    },
  },
  {
    path: '/MyApplyRzInfo',
    name: 'MyApplyRzInfo',
    component: () => import('@/modules/demand/rzCompanyInfo/PageMyApplyRzInfoList'),
    meta: {
      title: '我申请查看融资信息',
      isBlack: true,
      // fullscreen: true,
    },
  },
  {
    path: '/MySendToInvestor',
    name: 'MySendToInvestor',
    component: () => import('@/modules/demand/rzInvestorInfo/PageMySendToInvestorList'),
    meta: {
      title: '我投递的需求',
      isBlack: true,
      // fullscreen: true,
    },
  },
  {
    path: '/InvertorApplyAuth',
    name: 'InvertorApplyAuth',
    component: () => import('@/modules/demand/rzInvestorInfo/PageMyInvertorApplyAuthList'),
    meta: {
      title: '投资者申请查看授权',
      isBlack: true,
      // fullscreen: true,
    },
  },

]
